<template>
    <section class="b-comments" >

      <div class="row">
        <div class="col-lg-4 col-xxl-3 order-lg-1">
          <div class="b-comments-list__heading b-comments-list__heading--mobile">
            <div class="b-comments-list__btns">
              <button class="btn button-transparent-red b-comments-list__btn b-comments-list__btn--first" @click.prevent = "showModal">
                Написать
              </button>
            </div>
          </div>
          <rating-filter
              :common_rating="common_rating"
              :comments_count="comments_count"
              :ratings_count="ratings_count"
              :building_id="building_id"
              v-on:filter="filterComments"
              v-on:comments-sort="sortComments"
          ></rating-filter>

        </div>
        <div class="col-lg-8 col-xxl-9">
          <div class="b-comments-list__heading">
            <div class="b-comments-list__btns">
              <button class="btn button-transparent-red b-comments-list__btn--first" @click.prevent = "showModal">
                Добавить комментарий
              </button>
            </div>
            <div class="b-comments-list__filters">
              <button class="btn button-transparent b-comment-filters__btn" @click.prevent="sortComments('popular')">Популярные</button>
              <button class="btn button-transparent b-comment-filters__btn" @click.prevent="sortComments('date')">По дате</button>
            </div>
          </div>
          <list
              :building_id="building_id"
              v-on:answer-comment="commentAnswer"
              :auth="auth" @show-auth-modal="showModal" v-on:comments-count="commentsCount" ref="list"></list>
        </div>
      </div>
       <modal v-if="ShowModal && userCheck"
              v-on:close="closeModal"
              :user="user"
              :auth="auth"
              :building_id="building_id"
              :parent_id="parent_id"
              ref="commentModal"
              v-on:changeRating="changeRating"
              v-on:logout="logout"
              v-on:update-user="updateUser"
              v-on:register-user="registerUser"
              v-on:login="login"
              v-on:store-comment="$refs.list.getComments()"
       ></modal>
    </section>
</template>
<script>
    import { bus } from './components/bus';
    import { eventBus } from "../../app";
    import { Errors } from  '@/common/services/errors.js';
    import modal from './modal';
    import RatingFilter from "./components/rating-filter";
    import list from "./components/list";
    export default {
        components:{
            modal, RatingFilter,list
        },
        props:{
          building_id: Number,
          comment_modal:{
            type:Number,
            default:0,
          },
          common_rating:Number,
          ratings_count:Number
        },
        computed: {
            toggleButton: function () {
                let text, icon;
                if(this.formVisible === false) {
                    text  = 'Оставить отзыв';
                    icon =' fa-chevron-up';

                } else {
                    text = 'Скрыть форму';
                    icon =' fa-chevron-down';
                }
                return {text,icon}
            },

        },
        data() {
            return {
              user:{},
              formVisible:true,
              activeClass:'button-rounded--active',
              comments:[],
              auth:false,
              userCheck:false,
              ShowModal:false,
              errors: new Errors(),
              formSend:false,
              parent_id:0,
              comments_count:0,

            }
        },
        methods: {
          changeRating() {
            this.$refs.list.getComments();
          },
          commentsCount(value) {
            this.comments_count = value;
          },
          sortComments(type) {
            console.log(type);
            this.$refs.list.form['sort'] = type;


            this.$refs.list.getComments();
          },
          filterComments(data) {
            this.$refs.list.form['ratings'] = data;
            this.$refs.list.getComments();
          },
          showModal() {
            this.ShowModal = true;
            let vm =this;
            this.$nextTick(function () {
              $(function () {
                $('#commentModal').modal('show')
              })

            })
          },
          commentAnswer(id) {
            this.parent_id = id + 0;
            this.showModal();
          },
          closeModal() {
            $('#commentModal').modal('hide');
            this.comment_id = 0;
            let vm =this;
            $('#commentModal').on('hidden.bs.modal', function (e) {
              vm.ShowModal = false;
            })
          },
          registerUser(data) {
            this.getUser()
          },
          login() {
            this.getUser()
          },
          updateUser(data) {
              this.user = data;
          },
          getUser() {
            axios.get('/api/user')
                .then((response) => {
                  this.auth = true;
                  this.user = response.data;
                  this.userCheck = true;
                })
                .catch((error) => {
                  this.auth = false;
                  this.userCheck = true;
                });
          },

          logout() {
            axios.post('/logout').then(response => {
              if (response.status === 302 || 401) {
                this.auth = false;
                this.user = {};
                this.$refs.commentModal.checkAuth(false);
              } else {
                // throw error and go to catch block
              }
            }).catch(error => {
            });
          },
          scrollToComments() {
            var comments = document.getElementById("comments");
            comments.scrollIntoView({block: "start", inline: "start"});
          }
        },

      mounted() {
           this.getUser();
            if(this.comment_modal === 1) {
              let vm =this;
                $(function (){
                 vm.scrollToComments()
                  setTimeout(vm.showModal(), 10);
                })
            }
        },
      created() {
        bus.$on('show-auth-modal', this.showModal);
        bus.$on('sort-comments', this.sortComments())
        eventBus.$on('answer-comment', this.commentAnswer);

      }
    }
</script>
